export default __webpack_public_path__ + "static/media/mvp-layouts.39e7f81d.jpg";